export const OBTENER_CLIENTES = 'OBTENER_CLIENTES';
export const AGREGAR_CLIENTE = 'AGREGAR_CLIENTE';
export const FILTRAR_CLIENTES = 'FILTRAR_CLIENTES';
export const MOSTRAR_AGREGAR_CLIENTE = 'MOSTRAR_AGREGAR_CLIENTE';
export const MOSTRAR_CONFIRMACION = 'MOSTRAR_CONFIRMACION';
export const CLIENTE_ACTUAL = 'CLIENTE_ACTUAL';
export const ACTUALIZAR_CLIENTE = 'ACTUALIZAR_CLIENTE';
export const ELIMINAR_CLIENTE = 'ELIMINAR_CLIENTE';
export const CLIENTE_ERROR = 'CLIENTE_ERROR';

export const OBTENER_TRABAJOS = 'OBTENER_TRABAJOS';
export const OBTENER_TODOS_LOS_TRABAJOS = 'OBTENER_TODOS_LOS_TRABAJOS';
export const AGREGAR_TRABAJO = 'AGREGAR_TRABAJO';
export const ELIMINAR_TRABAJO = 'ELIMINAR_TRABAJO';
export const TRABAJO_ACTUAL = 'TRABAJO_ACTUAL';
export const EDITAR_TRABAJO = 'EDITAR_TRABAJO';
export const MOSTRAR_CONFIRMACION_T = 'MOSTRAR_CONFIRMACION_T';
export const ESTADO_EDITAR = 'ESTADO_EDITAR';

export const MOSTRAR_ALERTA = 'MOSTRAR_ALERTA';
export const OCULTAR_ALERTA = 'OCULTAR_ALERTA';

export const REGISTRO_EXITOSO = 'REGISTRO_EXITOSO';
export const REGISTRO_ERROR = 'REGISTRO_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const LOGIN_EXITOSO = 'LOGIN_EXITOSO';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CERRAR_SESION = 'CERRAR_SESION';

export const MOSTRAR_AGREGAR_INGRESO = 'MOSTRAR_AGREGAR_INGRESO';
export const MOSTRAR_CONFIRMACION_I = 'MOSTRAR_CONFIRMACION_I';
export const OBTENER_INGRESOS = 'OBTENER_INGRESOS';
export const AGREGAR_INGRESO = 'AGREGAR_INGRESO';
export const ACTUALIZAR_INGRESO = 'ACTUALIZAR_INGRESO';
export const ELIMINAR_INGRESO = 'ELIMINAR_INGRESO';
export const INGRESO_ACTUAL = 'INGRESO_ACTUAL';
export const INGRESO_ERROR = 'INGRESO_ERROR';
export const EDITAR_INGRESO = 'EDITAR_INGRESO';
export const FILTRAR_INGRESO = 'FILTRAR_INGRESO';
